<template>
    <div class="container" style="background:none;">
    <BaseLoading v-if="loading"></BaseLoading>
    <UgoForm
        v-if="!loading && !error"
        style="background:none"
        ref="form"
        :form="formDef"
        :value="value"
        :editable="editable"
        :old="old"
        :design="design"
        :acl="config.acl"
        @input="handleInput"
    />
    <div class="flex-wrap flex-center container" v-if="error">{{ error }}</div>
    </div>
  </template>

<script>
import UgoForm from '../index.vue';
import defaultValueMixin from '../mixins/default-value';
export default {
  mixins: [defaultValueMixin],
  cname: '内嵌表',
  corder: 81,
  icon: 'biaoge',
  components: {
    UgoForm,
  },
  data() {
    return {
      error: '请选择数据模型(model)',
      loading: false,
      formDef: {},
    };
  },
  watch: {
    'config.model': {
      handler(v) {
        if (v) {
          this.getRemoteData();
        } else {
          this.error='请选择数据模型';
        }
      },
      deep: true,
    },
  },
  props: {
    design: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
    fields: {
      type: Array,
      default: ()=>([]),
    },
    label: {
      type: String,
    },
    old: {
    },
    model: {
      type: Object,
      default: ()=>({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    old: {
      type: Object,
      default: ()=>({}),
    },
    editable: {
      type: Boolean,
    },
    config: {
      type: Object,
      default: ()=>({}),
    },

  },
  mounted() {
    if (this.config && this.config.model && (!this.formDef || !this.formDef.id)) {
      this.getRemoteData();
    }
  },
  properties: [
    {
      label: '数据模型',
      key: 'model',
      control: 'Select',
      option: {
        valueKey: 'key',
        getters: 'session/models',
      },
    }, {
      label: '可见性',
      key: 'acl',
      control: 'PermissionSelect',
    },

  ],
  methods: {
    handleInput(e) {
      this.$emit('input', e);
    },
    validate() {
      const form = this.$refs.form;
      console.log('form', this.$refs, form);

      return form.validate();
    },
    getUpdateData(e) {
      const data = this.$refs.form.getUpdateData();
      if (data) {
        delete data.id;
        return data;
      }
    },

    getRemoteData() {
      this.loading = true;
      this.$api.afterLogin(()=>{
        this.$api.get(`models/${this.config.model}?view=edit`).then((res)=>{
          this.formDef =res.data.data
          this.error = '';
        }).catch((e)=>{
          this.error = e?e.message:'加载错误';
        }).finally(()=>{
          this.loading =false;
        });
      });
    },

  },

  initModel(obj) {
    obj.config = {

    };
    return obj;
  },
};
</script>

  <style lang="scss" scoped>

  </style>
